export const CHECKLIST = "checklist";
export const SAFETY_CHECKLIST = "safetyChecklist";

